import { Link } from 'react-router-dom';
import { Clock, Film, Trash2 } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import JobStatusBadge from '@/components/jobs/JobStatusBadge';
import type { JobSummary } from '@/types/job';

interface JobCardProps {
  job: JobSummary;
  onDelete?: (jobId: string) => void;
}

function formatDate(timestamp: { seconds: number }): string {
  return new Date(timestamp.seconds * 1000).toLocaleString();
}

export default function JobCard({ job, onDelete }: JobCardProps) {
  return (
    <div className="relative group">
      <Link to={`/jobs/${job.id}`}>
        <Card className="hover:shadow-md transition-shadow cursor-pointer">
          <CardHeader className="pb-2">
            <div className="flex items-center justify-between">
              <CardTitle className="text-base truncate pr-8">&ldquo;{job.searchQuery}&rdquo;</CardTitle>
              <JobStatusBadge status={job.status} />
            </div>
          </CardHeader>
          <CardContent className="space-y-2">
            <div className="flex items-center gap-4 text-xs text-muted-foreground">
              <span className="flex items-center gap-1">
                <Film className="h-3 w-3" />
                {job.segmentCount} scene(s), {job.clipCount} clip(s)
              </span>
              <span className="flex items-center gap-1">
                <Clock className="h-3 w-3" />
                {job.createdAt ? formatDate(job.createdAt) : 'Unknown'}
              </span>
            </div>
          </CardContent>
        </Card>
      </Link>
      {onDelete && (
        <Button
          variant="ghost"
          size="icon"
          className="absolute top-3 right-12 opacity-0 group-hover:opacity-100 transition-opacity text-muted-foreground hover:text-destructive"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            if (confirm('Delete this job and all its clips?')) {
              onDelete(job.id);
            }
          }}
        >
          <Trash2 className="h-4 w-4" />
        </Button>
      )}
    </div>
  );
}
